export function parseThreadsUsername(input: string): string {
  let username = input.trim();

  // Handle full URL: https://www.threads.com/@username or threads.net
  if (
    username.includes("threads.com/") ||
    username.includes("threads.net/")
  ) {
    const parts = username.split(/threads\.(com|net)\/@?/);
    username = parts[parts.length - 1];
  }

  // Remove @ prefix
  if (username.startsWith("@")) {
    username = username.substring(1);
  }

  // Remove trailing slashes or query params
  username = username.split("/")[0].split("?")[0];

  return username;
}

export function getThreadsUrl(input: string): string {
  const username = parseThreadsUsername(input);
  return `https://www.threads.com/@${username}`;
}
